export default function   filterPath(path) {
  const prefix = '/root/workspace';
  // 检查路径是否以 '/root/workspace' 开头
  if (path.startsWith(prefix)) {
    // 如果是，去掉这个前缀
    return path.slice(prefix.length);
  }
  // 如果不是，返回原始路径
  return path;
}